import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ba-honors-eonomics',
  templateUrl: './ba-honors-eonomics.component.html',
  styleUrls: ['./ba-honors-eonomics.component.scss']
})
export class BaHonorsEonomicsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
